import { render, staticRenderFns } from "./NeoparentCreateLexiconEntry.vue?vue&type=template&id=786fc41c&scoped=true"
import script from "./NeoparentCreateLexiconEntry.vue?vue&type=script&lang=js"
export * from "./NeoparentCreateLexiconEntry.vue?vue&type=script&lang=js"
import style0 from "./NeoparentCreateLexiconEntry.vue?vue&type=style&index=0&id=786fc41c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786fc41c",
  null
  
)

export default component.exports